import copy from '../common/directives/copy'
import limit from '../common/directives/limit'
import number from '../common/directives/number'
import oneClick from '../common/directives/oneClick'
// 自定义指令
const directives={
    copy,
    limit,
    number,
    oneClick,
}

export default {
    install(Vue) {
        Object.keys(directives).forEach((key) => {
            Vue.directive(key, directives[key])
        })
    },
}



// WEBPACK FOOTER //
// ./src/common/directives.js